﻿import { create } from "zustand";

export const useRiskReportsStore = create((set) => ({
    data: [],
    loading: false,
    error: null,

    setData: (data) => set({ data }),
    setItems: (data) => set({ data }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    clearError: () => set({ error: null }),
}));
